module.exports = __webpack_public_path__ + "static/media/garage.01e1e84a.jpeg";